import React from "react";
import "./ExploreRowCards.css";

function ExploreRowCards() {
  return (
    <div className="exploreRow">
      <div className="exploreItem">
        <img src="https://picsum.photos/900" alt="explore card" />
      </div>
      <div className="exploreItem">
        <img src="https://picsum.photos/900" alt="explore card" />
      </div>
      <div className="exploreItem">
        <img src="https://picsum.photos/900" alt="explore card" />
      </div>
    </div>
  );
}

export default ExploreRowCards;
